var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1666 0.75C8.23826 0.75 6.3532 1.32183 4.74982 2.39317C3.14644 3.46451 1.89676 4.98726 1.1588 6.76884C0.420851 8.55042 0.227768 10.5108 0.603974 12.4021C0.98018 14.2934 1.90878 16.0307 3.27234 17.3943C4.6359 18.7579 6.37319 19.6865 8.2645 20.0627C10.1558 20.4389 12.1162 20.2458 13.8978 19.5078C15.6794 18.7699 17.2021 17.5202 18.2735 15.9168C19.3448 14.3134 19.9166 12.4284 19.9166 10.5C19.9139 7.91498 18.8858 5.43661 17.0579 3.60872C15.23 1.78084 12.7517 0.75273 10.1666 0.75ZM15.0023 6.16781L12.0023 12.1678C11.9655 12.2401 11.9068 12.2989 11.8344 12.3356L5.83444 15.3356C5.764 15.371 5.6842 15.3833 5.60638 15.3708C5.52856 15.3582 5.45667 15.3214 5.40093 15.2657C5.34519 15.21 5.30843 15.1381 5.29588 15.0603C5.28332 14.9824 5.29562 14.9026 5.33101 14.8322L8.33101 8.83219C8.36774 8.75987 8.4265 8.70111 8.49882 8.66437L14.4988 5.66437C14.5693 5.62899 14.6491 5.61669 14.7269 5.62925C14.8047 5.6418 14.8766 5.67856 14.9323 5.7343C14.9881 5.79004 15.0248 5.86193 15.0374 5.93975C15.0499 6.01757 15.0376 6.09737 15.0023 6.16781Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.5e8e56b9d87ac9bff3678daec368eef4.svg";
export { ForwardRef as ReactComponent };